import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Stack, Title, Button, Group, TextInput } from '@mantine/core'
import { IconPlus, IconSearch } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { servicesApi } from '@/api'
import { ServiceTable } from '@/components/ServiceTable'
import { ServiceDetail } from '@/components/ServiceDetail'
import { CreateServiceModal } from '@/components/CreateServiceModal'
import { useDisclosure } from '@mantine/hooks'

export function Services() {
  const { id } = useParams()
  const [search, setSearch] = useState('')
  const [createOpened, { open: openCreate, close: closeCreate }] = useDisclosure(false)

  const { data: services = [], isLoading, refetch } = useQuery({
    queryKey: ['services'],
    queryFn: async () => {
      const { data } = await servicesApi.list()
      return data
    },
    refetchInterval: 10000,
  })

  const filteredServices = services.filter((service) =>
    service.Spec.Name.toLowerCase().includes(search.toLowerCase())
  )

  if (id) {
    return <ServiceDetail serviceId={id} />
  }

  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Title order={2}>Services</Title>
        <Button leftSection={<IconPlus size={18} />} onClick={openCreate}>
          Create Service
        </Button>
      </Group>

      <TextInput
        placeholder="Search services..."
        leftSection={<IconSearch size={18} />}
        value={search}
        onChange={(e) => setSearch(e.currentTarget.value)}
      />

      <ServiceTable services={filteredServices} loading={isLoading} />

      <CreateServiceModal
        opened={createOpened}
        onClose={closeCreate}
        onSuccess={() => {
          closeCreate()
          refetch()
        }}
      />
    </Stack>
  )
}